import { twMerge } from 'tailwind-merge';

import { HeadingProps } from '@/types';

const sizeClasses = {
  h1: 'text-xl',
  h2: 'text-lg',
  h3: 'text-md',
  h4: 'text-base',
  h5: 'text-sm',
};

// Keep `html` attached to `text` so the discriminated HeadingProps union can
// guarantee that only a string reaches dangerouslySetInnerHTML. The ordinary
// child path accepts React nodes and remains the default.
const Heading: React.FC<HeadingProps> = (props): JSX.Element => {
  const { color = 'text-black', level, role, roleLevel, style = '' } = props;
  if (!sizeClasses[level]) {
    return <></>;
  }
  const Tag = level;
  const styles = `font-bold mb-6 last:mb-0`;
  const mergedStyles = twMerge(styles, color, sizeClasses[level], style);
  return (
    <>
      {props.html ? (
        <Tag
          className={mergedStyles}
          dangerouslySetInnerHTML={{ __html: props.text }}
          role={role}
          role-level={roleLevel}
        />
      ) : (
        <Tag className={mergedStyles} role={role} role-level={roleLevel}>
          {props.text}
        </Tag>
      )}
    </>
  );
};

export default Heading;
